import { render } from "./_vCardEmail.vue?vue&type=template&id=b4e3acf2"
import script from "./_vCardEmail.vue?vue&type=script&lang=js"
export * from "./_vCardEmail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/andreavadacchino/Desktop/pADV/untitled/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__